import React, { useState } from 'react';
import { pick } from 'ramda';
// import { useShowNotification } from 'js/components/common/Notifications';
import { Button } from 'js/components/main/LeaderboardButton/Button';
import { useDeviceSelector } from 'js/store/hooks';
import HeaderBanner from '../common/HeaderBanner';
import { useTranslations } from 'js/hooks/i18n';
import { setUserNickname } from './actions';
import style from './index.scss';
import { updateJoinState, useDynamicReducerDispatch, useDynamicReducerSelector } from '../Details/DetailedPage/state';
import { join } from '../Details/DetailedPage/network';
import classNames from '../Details/DetailedPage/common/classNames';
import { dispatcher } from '../../../../backbone/dispatcher';

export const notificationTKeyPrefix = 'playtech.mobile.system.pass-the-parcel.notification';

export default (props) => {
    const { isMobile, isDesktop, isLandscape, isTablet, isPortrait } = useDeviceSelector(pick([
        'isMobile', 'isDesktop', 'isLandscape', 'isTablet', 'isPortrait'
    ]));
    const ref = React.createRef();
    const [buttonEnabled, setButtonEnabled] = useState(true);
    const [errorMessage, setErrorMessage] = useState('description');
    const tt = useTranslations('playtech.mobile.mystery-parcel-page.nickName-page.');
    const mysteryParcelId = useDynamicReducerSelector(state => state.mysteryParcelId);
    // const showNotification = useShowNotification();

    const dispatch = useDynamicReducerDispatch();

    const sendSetNicknameRequest = (nickname, onSuccessAction, onErrorAction) => {

        if (clientSideVerification(nickname) !== true) {
            // there has been an error, return now, no need to ping the server.
            onErrorAction({ errorMessage: clientSideVerification(nickname) });
            return;
        }
        const userNicknamePromise = setUserNickname(nickname);
        userNicknamePromise.then(({ data }) => onSuccessAction(data))
            .catch(({ response }) => response && response.data && onErrorAction(response.data, nickname));
    };

    const clientSideVerification = (value) => {
        const modiValue = value.toString();
        // Length between 6 and 16 characters
        if (modiValue.length > 16 || modiValue.length < 6) {
            return 'validation error';
        }
        // Include only numbers and letters
        // No spaces or special characters
        if (modiValue.match(/[^A-Za-z0-9]/) !== null) {
            return 'Invalid value';
        }
        // No personally identifiable information (The most we would be able to do on the client for this is validate nickname != username)
        if (modiValue.toLowerCase() === window.Playtech.fetchUserDetails().username.toLowerCase()) {
            return 'matchingUserName';
        }
        // nothing wrong with clientside checks
        return true;
    };

    const onSuccess = () => {
        // When the server has confirmed the nickname has been set successfully
        if (/* props.leaderboardId && */!props.joined) {
            // If we got here with a leaderboardId then we should also join the leaderboard before going back to the previous page now that we have a nickname
            // const { leaderboardId } = props;
            // const getNotification = ({ data: { errorCode } }) => ({
            //     iconType: errorCode ? 'error' : 'joinLeaderboardNotification',
            //     tKey: `${notificationTKeyPrefix}.join.${errorCode ? 'error' : props.useTournament ? 'success.tournament' : 'success'}`
            // });
            // const success = (response) => {
            //     showNotification(getNotification(response));
            //     props.onNicknameSet();
            // };
            // const fail = (error) => {
            //     showNotification(getNotification(error));
            //     props.onNicknameSet();
            // };
            // join({ leaderboardId }).then(success, fail);
            join(mysteryParcelId).then(() => dispatch(updateJoinState({ joining: false, joined: true })),
                () => dispatch(updateJoinState({ joining: false, joined: false })));
            window.setTimeout(() => {
                dispatch(updateJoinState({
                    joining: false,
                    joined: true,
                    hasNickname: true,
                    displaySetNickname: false
                }));
                props.onNicknameSet();
            }, 2000);
        } else {
            // By default just complete if we don't have a leaderboard to join
            props.onNicknameSet();
        }
    };

    const onError = (errorData, nickname) => {
        // When the server rejects the nickname or we get an error
        const { errorCode } = errorData;
        if (errorCode === 303) {
            setButtonEnabled(true);
            dispatcher.dispatch('app:message', {
                ID: 'twoFactorAuthentication',
                data: {
                    onSuccess: () => sendSetNicknameRequest(nickname, onSuccess, onError),
                    resendHandler: () => sendSetNicknameRequest(nickname, onSuccess, onError)
                }
            });

            return;
        }
        setButtonEnabled(true);
        if (errorData.errorMessage) {
            setErrorMessage(getErrorDescription(errorData.errorMessage));
        }
    };

    const getErrorDescription = (localErrorMessage) => {
        if (localErrorMessage.search(/(validation error)/) !== -1) {
            return 'lengthError';
        } else if (localErrorMessage.search(/(Invalid value)/) !== -1) {
            return 'characterError';
        } else if (localErrorMessage.search(/(bad words)/) !== -1) {
            return 'badWordError';
        } else if (localErrorMessage.search(/(taken)/) !== -1) {
            return 'duplicateNameError';
        } else if (localErrorMessage.search(/(matchingUserName)/) !== -1) {
            return 'matchingUserName';
        }
        return 'genericError';
    };

    const landscape = () => (isLandscape || isTablet) && !isDesktop;
    const portrait = () => isPortrait && isMobile || isDesktop;

    return (
        <div className={classNames(style.parentContainer, { [style.mobileParentContainer]: isMobile,
        [style.mobilePortrait]: isPortrait })}>
            <HeaderBanner text={tt('header')} />
            <div className={portrait() ? style.portraitTopContainer : ''}>
                <p className={[style.descriptionText, style.description].join(' ')}>{tt(props.useTournament ? 'introduction.tournament' : 'introduction')}</p>
                <div className={portrait() ? '' : style.rowContainer}>
                    <div className={[style.inputContainer, style[errorMessage]].join(' ')}>
                        <input className={[style.input, style[errorMessage]].join(' ')} ref={ref}
                               placeholder={tt('defaultFieldValue')} maxLength={16} />
                    </div>
                    {landscape() &&
                    <Button variant='rounded' className={[style.submitButton, style.submitButtonLandscape].join(' ')}
                            disabled={!buttonEnabled} onClick={() => {
                        setButtonEnabled(false);
                        sendSetNicknameRequest(ref.current.value, onSuccess, onError);
                    }}>
                        {tt('buttonText')}
                    </Button>}
                </div>
                {portrait() &&
                <>
                    <p id='nickNameDescriptions'
                       className={[style.descriptionText, style[errorMessage]].join(' ')}>{tt(errorMessage)}</p>
                    <Button variant='rounded' className={[style.submitButton, style.submitButtonPortrait].join(' ')}
                        disabled={!buttonEnabled} onClick={() => {
                    setButtonEnabled(false);
                    sendSetNicknameRequest(ref.current.value, onSuccess, onError);
                }}>
                    {tt('buttonText')}
                </Button> </>}
                {landscape() &&
                <p id='nickNameDescriptions'
                   className={[style.descriptionText, style[errorMessage]].join(' ')}>{tt(errorMessage)}</p>}
            </div>
        </div>
    );

};
